module.exports = __webpack_public_path__ + "media/flags/bt-7c629ea7.svg";